export const logout = () => {
    localStorage.removeItem("insurlyUser");
};

export const getLocalToken = () => {
    try {
        return JSON.parse(localStorage.getItem('insurlyUser')).token;
    } catch (err) {
        console.log(err);
        return null;
    }
};